import {Howl, Howler} from 'howler';
import {TweenMax} from 'gsap';

export enum ESoundType
{
    AMBIANCE		= 0,
    EFFECT			= 1
}

interface ISoundResources
{
    [type:number] : {
        [index:string]:Howl
    }
}

export class SoundManager {

    protected _resources:ISoundResources;
    protected static _instance: SoundManager;
    protected _currentAmbiance!:Howl|null;
    protected _currentAmbianceVolume!:number;



    static get instance(): SoundManager {
        if (this._instance == null)
            this._instance = new SoundManager();
        return this._instance;
    }



    protected _muted!:boolean;
    get muted (): boolean { return this._muted }
    set muted (mute: boolean)
    {
        if (mute === this._muted) return;
        this._muted = mute;
        Howler.mute(this._muted);
    }


    public canAutoLoadSound() :boolean{
        return (Howler.ctx.state !== "suspended");
    }


    /**
     *
     * @param pType
     * @param pResourceHref
     * @param pOnComplete
     */
    load (pType:ESoundType, pResourceHref:string, pOnComplete ?: (pSoundAsset:Howl|null) => void):boolean
    {


        let sound = this.getSound(pType, pResourceHref);
        if ( sound != null )
        {
            pOnComplete && pOnComplete( sound );
            return true;
        }

        sound = new Howl({
            src: [ pResourceHref ],
            onload : () =>
            {
                pOnComplete && pOnComplete( sound );
            }
        });

        this._resources[ pType ][ pResourceHref ] = sound;

        return false;
    }

    /**
     *
     * @param pType
     * @param pKey
     */
    getSound (pType:ESoundType, pKey:string)
    {
        if ( !(pType in this._resources) )
            throw new Error(`SoundManager.play // Sound type ${pType} not found. Please use ESoundType enum from SoundManager.`);

        if ( !( pKey in this._resources[ pType ] ) )
            return null;

        return this._resources[ pType ][ pKey ];
    }

    /**
     *
     * @param pKey
     * @param pDuration
     * @param pVolume
     * @param pLoop
     */
    playAmbiance (pKey:string, pDuration = 1, pVolume = 1, pLoop = true)
    {


        /*
        if(Howler.ctx.state !== "running"){
            return;
        }
        */

        const sound = this.getSound(ESoundType.AMBIANCE, pKey);
        const msDuration = pDuration * 1000;

        //if (sound == this._currentAmbiance) return;

        // si nous avons déjà un son d'ambiance de lancé, nous le fadons
        if ( this._currentAmbiance != null )
        {
            const currentAmbiance = this._currentAmbiance;
            this._currentAmbiance = null;

            currentAmbiance.fade( currentAmbiance.volume(), 0, msDuration );
            currentAmbiance.once('fade', () =>
            {
                currentAmbiance.stop();
            });
        }


        // nous trouvons le son dans notre bibliotheque, du coup, nous le lancons
        if ( sound != null )
        {
            //console.debug('play', pVolume, msDuration);
            sound.loop( pLoop );
            sound.play();
            sound.fade(0, pVolume, msDuration);

            this._currentAmbianceVolume = pVolume;
            this._currentAmbiance = sound;
        }

    }

    stopAmbiance (pDuration:number = 1 )
    {
        const sound = this._currentAmbiance;
        const msDuration = pDuration * 1000;

        if (!sound) return;

        sound.fade(this._currentAmbianceVolume, 0, msDuration);
        TweenMax.delayedCall(pDuration, () =>
        {
            sound.stop();
            this._currentAmbiance = null;
        });
    }



    constructor ()
    {
        this._resources = {};
        this._resources[ ESoundType.AMBIANCE ] = {};
        this._resources[ ESoundType.EFFECT ] = {};
        this.muted = false;
    }


}